module.exports = __webpack_public_path__ + "static/media/Icon_Quizzes_Grey70.ba2cab63.png";